<template>
  <div id="projBidQuotationDetail">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" :lastText="project.departName" />
    </eb-header>
    <div class="eb-button-group">
      <template v-if="userId == project.buyUserId">
        <el-button
          @click="chooseReply"
          :disabled="!(project.projectStatus == '6' && project.quoteStatus == '10')"
          class="eb-button-group-btn eb-button-orange eb-button-big"
          >选中</el-button
        >
      </template>
      <el-button
        @click="goBack"
        v-if="project.projectStatus == 7"
        class="eb-button-group-btn eb-button-orange eb-button-big"
        >返回汇总页
      </el-button>
      <el-button @click="downloadFile" class="eb-button-group-btn eb-button-orange eb-button-big">下载附件</el-button>
    </div>
    <div class="card-box">
      <eb-card-three>
        <ProjBidQuotationDetailProject :project="project" :no="no" />
      </eb-card-three>
    </div>
    <div class="eb-line"></div>
    <ProjectViewQuotationDetail :project="project" class="panel-box" />
    <div class="eb-line"></div>
    <div class="rule-answer-view">
      <ProjRuleAnswerViewList :ruleAnswerList="ruleAnswerList" />
    </div>
    <ProjectViewHandsontable
      :title="projectHandsontableTitle"
      :hotSettings="shoppingListHotSettings"
      :total="project.quoteMin"
      :isTotalShow="true"
      class="panel-box"
    />
    <div class="eb-line"></div>
    <ProjectViewPreText :title="projectViewCommentTitle" :content="project['projectComment']" class="panel-box" />
    <div class="eb-line"></div>
    <ProjectViewPreText :title="quotationStatementTitle" :content="project['quoteStatement']" class="panel-box" />

  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebCardThree from '@/components/common/card/eb-card-three';
import ProjRuleAnswerViewList from '@/components/project/common/rule-answer-view/ProjRuleAnswerViewList';
import ProjBidQuotationDetailProject from '@/components/project/bid/quotation/ProjBidQuotationDetailProject';
import ProjectViewQuotationDetail from '@/components/project/common/ProjectViewQuotationDetail';
import ProjectViewHandsontable from '@/components/project/common/ProjectViewHandsontable';
import ProjectViewPreText from '@/components/project/common/ProjectViewPreText';
import { handleProjRuleAnswerList } from '@/services/proj/project-service';
import { getProjectAndReply } from '@/services/proj/bid-project-service';
import { listSupplier } from '@/services/proj/bid-shopping-list-service';
import { listAnswer } from '@/services/proj/bid-rule-answer-service';
import { chooseReply } from '@/services/proj/bid-reply-service';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'projBidQuotationDetail',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebCardThree,
    ProjBidQuotationDetailProject,
    ProjectViewQuotationDetail,
    ProjectViewHandsontable,
    ProjectViewPreText,
    ProjRuleAnswerViewList
  },
  data() {
    return {
      userId: this.$store.state.user.userInfo.userid,
      projectId: this.$route.params.projectId,
      supplierDepartId: this.$route.params.supplierDepartId,
      supplierUserId: this.$route.params.supplierUserId,
      no: this.$route.params.no,
      project: {},
      ruleAnswerList: [],
      projectHandsontableTitle: {
        number: '1',
        text: '分项报价表'
      },
      projectViewCommentTitle: {
        number: '2',
        text: '报价表备注'
      },
      quotationStatementTitle: {
        number: '3',
        text: '报价声明'
      },
      shoppingListHotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['名称', '描述', '单位', '数量', '单价(投标方填写)', '总价', '备注'],
        renderAllRows: true,
        fillHandle: false,
        data: [],
        columns: [
          {
            data: 'productName',
            type: 'text',
            width: 90,
            readOnly: true
          },
          {
            data: 'productDesc',
            type: 'text',
            width: 430,
            readOnly: true
          },
          {
            data: 'productUnit',
            type: 'text',
            width: 40,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'productNum',
            width: 70,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'supplierPrice',
            width: 140,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'supplierSubtotal',
            width: 110,
            className: 'htRight',
            type: 'numeric',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric',
            readOnly: true
          },
          {
            data: 'remark',
            width: 70,
            renderer: 'html',
            className: 'htCenter',
            readOnly: true
          }
        ]
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let [{ data: data1 }, { data: data2 }, { data: data3 }] = await Promise.all([
          getProjectAndReply(this.projectId, this.supplierUserId),
          listSupplier(this.projectId, this.supplierUserId),
          listAnswer(this.projectId, this.supplierUserId)
        ]);
        if (data1.returnCode === '01') {
          this.project = data1.project;
          console.log(this.project);
        } else {
          this.$message.error('获取项目信息失败');
        }
        if (data2.returnCode === '01') {
          this.shoppingListHotSettings.data = data2.supplierList;
        } else {
          this.$message.error('获取采购清单信息失败');
        }
        if (data3.returnCode === '01') {
          this.ruleAnswerList = handleProjRuleAnswerList(data3.ruleList);
          this.changeTitleNumber(parseInt(this.ruleAnswerList.length));
        } else {
          this.$message.error('获取应答规则列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    changeTitleNumber: function(number) {
      this.projectHandsontableTitle.number = number + 1;
      this.projectViewCommentTitle.number = number + 2;
      this.quotationStatementTitle.number = number + 3;
    },
    chooseReply: function() {
      if ('' + this.project.projectStatus !== '6') {
        this.$message.error('只有待选定的招标项目才可以进行选中操作');
        return;
      }
      if ('' + this.project.quoteStatus !== '10') {
        this.$message.error('只有已开标的报价才可以进行选中操作');
        return;
      }
      this.$ebConfirm('确认选中【' + this.project.departName + '】吗?')
        .then(() => {
          this.chooseReplyService();
        })
        .catch(() => {});
    },
    async chooseReplyService() {
      let params = {
        projectId: this.project.projectId,
        replyId: this.project.replyId
      };
      try {
        let { data } = await chooseReply(params);
        if (data.returnCode === '01') {
          this.$message.success('选中成功');
          this.init();
        } else if (data.returnCode === '05') {
          this.$message.error(data.errorMsg);
        } else if (data.returnCode === '03') {
          this.$message.error('参数不完整');
        } else {
          this.$message.error('操作失败,请联系管理员！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    goBack: function() {
      this.$router.push('/projbid/quotation/summary/' + this.projectId);
    },
    downloadFile: function() {
      location.href =
        baseURL + '/api/reports/r4/' + this.supplierUserId + '/' + this.projectId + '/' + this.project.replyId + '.pdf';
    }
  }
};
</script>
<style scoped lang="less">
.card-box {
  margin-bottom: 30px;
}
</style>
